import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { DEPLOY_URL } from './app/hub-components/variables';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const DEPLOY_URL_PROVIDER = {provide: DEPLOY_URL, useValue: environment.deployUrl};

platformBrowserDynamic([DEPLOY_URL_PROVIDER]).bootstrapModule(AppModule);
